export const notificationsEs = {
  notificationSystem: {
    title: "Sistema de Notificaciones",
    subtitle: "Envía correos electrónicos y SMS reales. Configura informes semanales automatizados.",
    sendNotifications: "Enviar Notificaciones",
    history: "Historial",
    weeklyReports: "Informes Semanales",
    emailNotification: "Notificación por Email",
    recipientEmail: "Email del Destinatario",
    subject: "Asunto",
    subjectPlaceholder: "Alerta: Alto riesgo detectado en tu parcela",
    message: "Mensaje",
    messagePlaceholder: "Tu parcela 'Viñedo Norte' muestra NDVI por debajo del umbral...",
    sendEmail: "Enviar Email",
    smsNotification: "Notificación SMS",
    phoneNumber: "Número de Teléfono",
    smsPlaceholder: "ALERTA: La parcela Viñedo Norte muestra condiciones de alto riesgo. Revisar panel inmediatamente.",
    characters: "caracteres",
    sendSms: "Enviar SMS",
    weeklyReport: "Informe Semanal",
    sendWeeklyReportDesc: "Enviar un informe semanal completo ahora",
    generateAndSend: "Generar y Enviar Informe Semanal Ahora",
    notificationHistory: "Historial de Notificaciones",
    noNotifications: "Aún no se han enviado notificaciones",
    automatedConfig: "Configuración de Informes Semanales Automáticos",
    automatedConfigDesc: "Los informes semanales se envían automáticamente cada lunes a las 06:00 UTC",
    automatedActive: "Informes Automáticos Activos",
    automatedActiveDesc: "Los informes semanales se generan y envían automáticamente cada lunes a las 06:00 UTC para todos los usuarios con email registrado.",
    reportIncludes: "El Informe Semanal Incluye:",
    reportItem1: "Resumen de todos los análisis de parcelas",
    reportItem2: "Tendencias y cambios de NDVI",
    reportItem3: "Patrones meteorológicos y pronósticos",
    reportItem4: "Evaluaciones de riesgo y alertas",
    reportItem5: "Actualizaciones de estado de reclamaciones de seguro",
    reportItem6: "Recomendaciones accionables",
    autoScheduling: "Programación Automática",
    nextScheduledReport: "Próximo informe programado: Lunes 06:00 UTC",
    reportsProcessed: "Los informes se procesan automáticamente y se envían por email a todos los usuarios registrados.",
    invalidEmail: "Email Inválido",
    invalidEmails: "Direcciones de Email Inválidas",
    notificationSimulated: "Notificación Simulada",
    notificationSent: "Notificación Enviada",
    generatingReport: "Generando Informe",
    generatingReportDesc: "Creando tu informe semanal...",
    weeklyReportQueued: "Informe Semanal en Cola",
    weeklyReportQueuedDesc: "Tu informe semanal ha sido generado y puesto en cola para envío por email. Revisa tus registros de notificaciones en unos momentos.",
    errorSending: "Error al enviar notificación. Inténtalo de nuevo.",
    errorWeeklyReport: "Error al generar informe semanal. Inténtalo de nuevo.",
    mustBeLoggedIn: "Debes iniciar sesión para enviar notificaciones",
    mustBeLoggedInReports: "Debes iniciar sesión para enviar informes semanales"
  }
};
